import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var ExpenseService = /** @class */ (function () {
    function ExpenseService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    ExpenseService.prototype.find = function (params) {
        var api = _GlobalNS.api.expense.search;
        return this._http.get("" + api, { params: params });
    };
    ExpenseService.prototype.findCounterByPropertyId = function () {
        var api = _GlobalNS.api.expense.counter;
        var propertyId = this._global.find(_GlobalNS.paths.PropertyId);
        var params = new HttpParams().set('PropertyId', propertyId);
        return this._http.get("" + api, { params: params });
    };
    ExpenseService.ngInjectableDef = i0.defineInjectable({ factory: function ExpenseService_Factory() { return new ExpenseService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: ExpenseService, providedIn: "root" });
    return ExpenseService;
}());
export { ExpenseService };
